/**
 * This util is used to trigger downloading multiple files at once.
 * This is not duplicated with ak-ipp-cloud-kira-b50-frontend/src/services/web/src/util/export.js because of this issue:
 * https://stackoverflow.com/questions/52051330/browser-is-cancelling-multiple-file-download-requests
 */

export const downloadElement = (fileUrl, fileName) => {
  if (!fileUrl) return;

  const iframe = document.createElement('iframe');
  iframe.setAttribute('sandbox', 'allow-downloads allow-scripts');
  iframe.src = fileUrl;
  iframe.name = fileName;
  iframe.setAttribute('style', 'display: none');

  document.body.appendChild(iframe);
};
